import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/not-found.tsx");
